import type { Options as ReactMarkdownOptions } from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';

// These fields are authored as markdown. Raw HTML in them is a defect (for
// example a migration writing <a href> instead of a markdown link), and this
// config guards against it rather than supporting it: rehype-raw parses the
// HTML so a stray anchor still renders as a link instead of literal tags, and
// rehype-sanitize keeps only the allowlisted inline tags below. Anything else
// is flattened to its text, and unsafe markup (scripts, event handlers,
// javascript: URLs) is removed. Order matters: raw must run before sanitize.
const inlineProseSchema = {
  ...defaultSchema,
  tagNames: ['p', 'a', 'strong', 'em', 'b', 'i', 'code', 'span', 'br'],
};

/**
 * ReactMarkdown `rehypePlugins` for short authored text lines (CTA subtext,
 * incentive lines, descriptions) that may contain inline markdown or inline HTML.
 */
export const inlineMarkdownRehypePlugins: NonNullable<ReactMarkdownOptions['rehypePlugins']> = [
  rehypeRaw,
  [rehypeSanitize, inlineProseSchema],
];
